import React, { Component } from 'react';
import * as settings from '../../services/settings';

export default class RestrictedToAdmin extends Component
{

	render() {
		return settings.showAdminFunctions() ? this.props.children : null;
	}
}


// WEBPACK FOOTER //
// ./React/src/components/general/RestrictedToAdmin.js